/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Error_Expired7Inputs */

const en_us2_body_assessment_error_expired7 = /** @type {(inputs: Body_Assessment_Error_Expired7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This result expired before it reached us. Run the assessment again to get a new one.`)
};

const pt_br2_body_assessment_error_expired7 = /** @type {(inputs: Body_Assessment_Error_Expired7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este resultado expirou antes de chegar até aqui. Refaça a avaliação para gerar um novo.`)
};

const es_419_body_assessment_error_expired7 = /** @type {(inputs: Body_Assessment_Error_Expired7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este resultado venció antes de llegarnos. Vuelve a hacer la evaluación para obtener uno nuevo.`)
};

const pt_pt2_body_assessment_error_expired7 = /** @type {(inputs: Body_Assessment_Error_Expired7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este resultado expirou antes de chegar até aqui. Repete a avaliação para gerar um novo.`)
};

const fr_fr2_body_assessment_error_expired7 = /** @type {(inputs: Body_Assessment_Error_Expired7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce résultat a expiré avant de nous parvenir. Refais l'évaluation pour en obtenir un nouveau.`)
};

const de_de2_body_assessment_error_expired7 = /** @type {(inputs: Body_Assessment_Error_Expired7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Ergebnis ist abgelaufen, bevor es bei uns ankam. Mach die Messung erneut, um ein neues zu erhalten.`)
};

const it_it2_body_assessment_error_expired7 = /** @type {(inputs: Body_Assessment_Error_Expired7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo risultato è scaduto prima di arrivare qui. Rifai la valutazione per ottenerne uno nuovo.`)
};

/**
* | output |
* | --- |
* | "This result expired before it reached us. Run the assessment again to get a new one." |
*
* @param {Body_Assessment_Error_Expired7Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_error_expired7 = /** @type {((inputs?: Body_Assessment_Error_Expired7Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Error_Expired7Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_error_expired7(inputs)
	if (locale === "es-419") return es_419_body_assessment_error_expired7(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_error_expired7(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_error_expired7(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_error_expired7(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_error_expired7(inputs)
	return en_us2_body_assessment_error_expired7(inputs)
});
export { body_assessment_error_expired7 as "body-assessment.error.EXPIRED" }